"use client"

import { useRouter, useSearchParams } from "next/navigation"
import { useState, useTransition } from "react"

interface SearchFormProps {
  placeholder?: string
  action: string
}

export default function SearchForm({ placeholder = "Search...", action }: SearchFormProps) {
  const router = useRouter()
  const searchParams = useSearchParams()
  const [isPending, startTransition] = useTransition()
  const [query, setQuery] = useState(searchParams.get("q") || "")

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    const params = new URLSearchParams()
    if (query.trim()) {
      params.set("q", query.trim())
    }
    startTransition(() => {
      router.push(`${action}${params.toString() ? `?${params.toString()}` : ""}`)
    })
  }

  function handleClear() {
    setQuery("")
    startTransition(() => {
      router.push(action)
    })
  }

  return (
    <form onSubmit={handleSubmit} className="flex gap-3">
      <div className="relative flex-1">
        <i className="bootstrap-search absolute left-4 top-1/2 -translate-y-1/2 text-lg text-gray-400" />
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={placeholder}
          className="w-full rounded-lg border border-gray-300 bg-white py-4 pl-12 pr-10 text-base placeholder:text-gray-400 focus:border-amber-500 focus:outline-none focus:ring-1 focus:ring-amber-500"
        />
        {query && (
          <button
            type="button"
            onClick={handleClear}
            className="absolute right-3 top-1/2 -translate-y-1/2 rounded p-1 text-gray-400 hover:text-gray-600"
          >
            <i className="bootstrap-x-lg text-lg" />
          </button>
        )}
      </div>
      <button
        type="submit"
        disabled={isPending}
        className="rounded-lg bg-amber-500 px-6 py-4 text-base font-semibold text-white hover:bg-amber-400 disabled:opacity-50 transition-colors"
      >
        {isPending ? "..." : "Search"}
      </button>
    </form>
  )
}
